export const MAX_PIXEL_WIDTH = "10000";
export const MAX_PIXEL_HEIGHT = "10000";
export const EW_ADDITIONAL_VEHICLE_COMPONENTS = "additionalVehicleComponents";
export const EW_HYBRID_ELECTRIC = "hybridElectric";
export const PROTECTION_RIGHTRIDE_CA_EMAIL = "";
export const CERTIFICATE_OF_INSPECTION_URL =
  "https://www.google.com/search?q=example+of+certificate+of+inspection+in+my+province";
export const CONDITIONALLY_SUCCESSFUL_CHROME_DECODE = "ConditionallySuccessful";
export const HOW_TO_ALLOW_POPUPS_URL =
  "https://www.google.com/search?q=how+to+enable+popup+on+this+device";
export const ROADWISE_CONTACT = "+1 825 402-1776";
